<template>
  <div class="container page task-record-page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
            v-if="list.length === 0"
            :description="$t('withdraw.empty_data')"
        />

        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <span class="period-number">NO. {{ v.expect  }}</span>
            <span
                class="status-text"
                :class="{ success: v.status === 1 }"
            >
              {{ v.status_text }}
            </span>
          </div>

          <div class="recent">
            <div class="kuaisan-ball left">
              <span class="result-label">{{ $t("reservation.result") }}</span>
              <span class="ressquareBox">{{ v.sizeLabel }}</span>
              <span class="ressquareBox purple">{{ v.doubleLabel }}</span>
            </div>
          </div>

          <div class="topInfo">
            <span>{{ $t("reservation.money") }}：{{ v.money }}</span>
          </div>

          <div class="time">
            <span>{{ $t("reservation.order_time") }}：{{ v.create_time }}</span>
          </div>

          <div class="time">
            <span>{{ $t("reservation.settle_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },

    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getUserGameList();
        this.isLoading = false;
      }, 500);
    },

    getCurrentLang() {
      return localStorage.getItem("lang") || "zh";
    },

    getLabelConfig(lang) {
      const config = {
        zh: {
          big: "玫瑰",
          small: "百合",
          odd: "烟花",
          even: "气球",
        },
        tw: {
          big: "玫瑰",
          small: "百合",
          odd: "煙花",
          even: "氣球",
        },
        en: {
          big: "Flower",
          small: "Balloon",
          odd: "Fireworks",
          even: "Lollipop",
        },
        ja: {
          big: "花",
          small: "風船",
          odd: "花火",
          even: "キャンディ",
        },
        ko: {
          big: "꽃",
          small: "풍선",
          odd: "불꽃놀이",
          even: "막대사탕",
        },
      };
      return config[lang] || config.zh;
    },

    getSizeLabel(sum, lang) {
      const labels = this.getLabelConfig(lang);
      return sum >= 11 && sum <= 18 ? labels.big : labels.small;
    },

    getOddEvenLabel(sum, lang) {
      const labels = this.getLabelConfig(lang);
      return sum % 2 === 0 ? labels.even : labels.odd;
    },

    getUserGameList() {
      this.$http({
        method: "get",
        url: "user_get_game_list",
      }).then((res) => {
        if (res.code === 200) {
          const lanng = this.getCurrentLang();

          this.list = (res.data || []).map((item) => {
            let sum = 0;

            if (item.opencode && item.opencode.length >= 3) {
              sum =
                  Number(item.opencode[0]) +
                  Number(item.opencode[1]) +
                  Number(item.opencode[2]);
            }

            return {
              ...item,
              sum,
              sizeLabel: this.getSizeLabel(sum, lanng),
              doubleLabel: this.getOddEvenLabel(sum, lanng),
            };
          });

          console.log(this.list, "user_game_list");
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.task-record-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #211923 url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png") no-repeat top center;
  background-size: cover;
}

.task-record-page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
      linear-gradient(180deg, rgba(18, 14, 20, 0.25) 0%, rgba(44, 25, 47, 0.55) 48%, rgba(88, 53, 83, 0.82) 100%),
      rgba(30, 20, 33, 0.25);
}

.task-record-page > * {
  position: relative;
  z-index: 1;
}

.nav-bar {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
}

::v-deep .van-nav-bar__left {
  left: 18px;
}

::v-deep .van-icon-arrow-left {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  font-size: 40px !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #fff;
  font-size: 32px;
}

::v-deep .van-loading__text {
  color: #fff;
  font-size: 32px;
}

::v-deep .van-empty__description {
  color: rgba(255, 255, 255, 0.75);
  font-size: 28px;
}

.main {
  position: relative;
  height: calc(100vh - 92px);
  overflow-y: auto;
  padding: 20px 22px 40px;
  box-sizing: border-box;
}

.item_list {
  padding: 24px 26px;
  margin: 0 0 22px;
  border-radius: 22px;
  background: rgba(112, 99, 110, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow:
      0 18px 34px rgba(0, 0, 0, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.lottery_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.period-number {
  font-size: 34px;
  font-weight: 900;
  color: #fff;
  line-height: 1.3;
}

.status-text {
  font-size: 26px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.7);
}

.status-text.success {
  color: #75f08b;
}

.recent {
  display: flex;
  align-items: center;
  min-height: 76px;
  margin-top: 12px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.result-label {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  margin-right: 16px;
}

.ressquareBox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  height: 42px;
  padding: 0 16px;
  margin-right: 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f26b6f 0%, #e33983 100%);
  color: #fff;
  font-size: 24px;
  font-weight: 900;
  box-sizing: border-box;
  box-shadow: 0 8px 18px rgba(227, 57, 131, 0.28);
}

.ressquareBox.purple {
  color: #303134;
  background: linear-gradient(135deg, #e9c6f6 0%, #c897dd 100%);
}

.topInfo {
  margin-top: 12px;
}

.topInfo span {
  font-size: 30px;
  font-weight: 800;
  color: #ff4f94;
  line-height: 1.5;
}

.time {
  margin-top: 6px;
}

.time span {
  font-size: 24px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.5;
}
</style>